import { put, call, all, takeEvery, select } from "redux-saga/effects";
import _ from "lodash";
import { IMAGE, ENDPOINT } from "../constants";
import { setPageTopLoader, setAllImageDataByFileName } from "../actions";
import { getDataFromKpiDash } from "../api";

const S3_BUCKET_BASE_URL = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const selectAllImageData = (state) => state.image.allImageDataByFilename;

export function buildQueryGetPpa(fileName) {
  const safeFileName = fileName.replace(/'/g, "''");
  return {
    query: `
      SELECT
        ppa.id AS ppa_id,
        ppa.file_name,
        ppa.object_key,
        ppa.power_asset_id,
        ppa.player_id,
        ppa.game_space_id
      FROM photo_of_power_asset ppa
      WHERE ppa.file_name = '${safeFileName}'
      ORDER BY ppa.id DESC
      LIMIT 1;
    `
  };
}

export function buildQueryHasRrpb(ppaId) {
  return {
    query: `
      SELECT rrpb.review_request_id
      FROM review_request_photo_bind rrpb
      WHERE rrpb.photo_of_power_asset_id = '${ppaId}'
      LIMIT 1;
    `
  };
}

export function buildQuery1(fileName) {
  const env = process.env.REACT_APP_ENV;
  const companyTableName = localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9"
  ? "power_asset_detail_of_ntt_me" : localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3"
  ? "power_asset_detail_of_hepco" : localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb"
    ?  env === "prod" ? "power_asset_detail_of_ntt_ft" : "power_asset_detail_of_ntt_me"
    : "power_asset_detail_of_tepco";
  return {
    query: `
      SELECT
          ppa.*,
          gs.*,
          gt.*,
          pae.occurred_datetime AS occurred_datetime,
          CONVERT_TZ(pae.occurred_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
          ps.*,
          padtep.*,
          rrpb.review_request_id
      FROM
          power_asset_event pae
      JOIN
          photo_of_power_asset ppa ON ppa.power_asset_id = pae.power_asset_id
          AND ppa.player_id = pae.player_id
          AND ppa.game_space_id = pae.game_space_id
      JOIN
          game_space gs ON gs.id = pae.game_space_id
      JOIN
          game_term gt ON gt.id = gs.game_term_id
      JOIN
          player_state ps ON pae.player_id = ps.player_id
      JOIN
          ${companyTableName} padtep ON pae.power_asset_id = padtep.power_asset_id
      JOIN review_request_photo_bind rrpb ON rrpb.photo_of_power_asset_id = ppa.id
      WHERE
          pae.type = 'PHOTOGRAPH'
          AND ppa.file_name = '${fileName}'
      GROUP BY
          pae.power_asset_id, ps.player_id, occurred_datetime
      ORDER BY
          pae.occurred_datetime DESC
      LIMIT 1
    `
  };
}

export function buildQuery2(reviewRequestId) {
  const env = process.env.REACT_APP_ENV;
  const companyTableName = localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9"
  ? "power_asset_detail_of_ntt_me" : localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3"
  ? "power_asset_detail_of_hepco" : localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb"
    ? env === "prod" ? "power_asset_detail_of_ntt_ft" : "power_asset_detail_of_ntt_me"
    : "power_asset_detail_of_tepco";
  return {
    query: `
      SELECT
        *,
        DATE_FORMAT(CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00'), '%Y-%m-%d %H:%i:%s') AS occurred_datetime_jst
      FROM review_request_photo_bind rrpb
      JOIN photo_of_power_asset ppa ON rrpb.photo_of_power_asset_id = ppa.id
      JOIN game_space gs ON gs.id = ppa.game_space_id
      JOIN game_term gt ON gt.id = gs.game_term_id
      JOIN ${companyTableName} padtep ON ppa.power_asset_id = padtep.power_asset_id
      JOIN player_state ps ON ps.player_id = ppa.player_id
      JOIN review_request_event rre ON rrpb.review_request_id = rre.review_request_id
      WHERE rrpb.review_request_id = '${reviewRequestId}'
      AND rre.type = 'APPROVED';
    `
  };
}

export function buildQuery2NewSeasonByFileName(fileName) {
  const env = process.env.REACT_APP_ENV;
  const companyTableName =
    localStorage.getItem("access_key") === "qf70ypdjdzm89ypqvc4r7nf9"
      ? "power_asset_detail_of_ntt_me"
      : localStorage.getItem("access_key") === "lqdp4c7fuwgfz89og7q4x9f3"
      ? "power_asset_detail_of_hepco"
      : localStorage.getItem("access_key") === "z7n3q9m1x4p2v0ydk8twr5fb"
      ? env === "prod"
        ? "power_asset_detail_of_ntt_ft"
        : "power_asset_detail_of_ntt_me"
      : "power_asset_detail_of_tepco";

  const safeFileName = fileName.replace(/'/g, "''");

  return {
    query: `
      WITH target AS (
        SELECT
          ppa.power_asset_id,
          ppa.player_id,
          ppa.game_space_id,
          pae.occurred_datetime
        FROM photo_of_power_asset ppa
        JOIN power_asset_event pae
          ON pae.power_asset_id = ppa.power_asset_id
        AND pae.player_id      = ppa.player_id
        AND pae.game_space_id  = ppa.game_space_id
        AND pae.type           = 'PHOTOGRAPH'
        WHERE ppa.file_name = '${safeFileName}'
        ORDER BY pae.occurred_datetime DESC
        LIMIT 1
      )
      SELECT
        ppa.*,
        gs.*,
        gt.*,
        ps.*,
        padtep.*,
        DATE_FORMAT(
          CONVERT_TZ(t.occurred_datetime, '+00:00', '+09:00'),
          '%Y-%m-%d %H:%i:%s'
        ) AS occurred_datetime_jst
      FROM target t
      JOIN photo_of_power_asset ppa
        ON ppa.power_asset_id = t.power_asset_id
      AND ppa.player_id      = t.player_id
      AND ppa.game_space_id  = t.game_space_id
      JOIN power_asset_event pae
        ON pae.power_asset_id = ppa.power_asset_id
      AND pae.player_id      = ppa.player_id
      AND pae.game_space_id  = ppa.game_space_id
      AND pae.type           = 'PHOTOGRAPH'
      AND pae.occurred_datetime = t.occurred_datetime
      JOIN game_space gs ON gs.id = ppa.game_space_id
      JOIN game_term gt ON gt.id = gs.game_term_id
      JOIN player_state ps ON ps.player_id = ppa.player_id
      JOIN ${companyTableName} padtep ON ppa.power_asset_id = padtep.power_asset_id
      ORDER BY ppa.file_name ASC;
    `
  };
}

export function* handleAllImageDataByFileName(action) {
  try {
    yield put(setPageTopLoader(true));

    const fileNames = action.payload; // 配列
    let allImageUrls = [];

    const fetchedGroupKeys = new Set(); // 重複クエリ防止

    // 各ファイル名に対して処理
    for (const url of fileNames) {
      const decodedUrl = decodeURIComponent(url);
      const fileName = decodedUrl.split("/").pop();

      // ① ppa取得
      const sqlGetPpa = buildQueryGetPpa(fileName);
      const ppaTemp = yield call(getDataFromKpiDash, sqlGetPpa, ENDPOINT.GET_DATA_API_REPLICA);
      const ppaRows = JSON.parse(ppaTemp.body || "[]");
      if (!ppaRows.length) {
        console.warn(`No ppa found for file: ${fileName}`);
        continue;
      }

      const { ppa_id } = ppaRows[0];

      // ② rrpb有無チェック
      const sqlHasRrpb = buildQueryHasRrpb(ppa_id);
      const rrpbTemp = yield call(getDataFromKpiDash, sqlHasRrpb, ENDPOINT.GET_DATA_API_REPLICA);
      const rrpbRows = JSON.parse(rrpbTemp.body || "[]");
      const reviewRequestId = rrpbRows?.[0]?.review_request_id;

      // ③ ここで “同一グループ” の重複を避ける
      const groupKey = reviewRequestId ? `rr:${reviewRequestId}` : `fn:${fileName}`;
      if (fetchedGroupKeys.has(groupKey)) continue;
      fetchedGroupKeys.add(groupKey);

      // ④ Query2 分岐
      const sqlQuery2 = reviewRequestId
        ? buildQuery2(reviewRequestId)                 // 旧（rrpbあり）
        : buildQuery2NewSeasonByFileName(fileName);    // 新（rrpbなし）

      const imageFilesDataTemp = yield call(getDataFromKpiDash, sqlQuery2, ENDPOINT.GET_DATA_API_REPLICA);
      const imageFilesData = JSON.parse(imageFilesDataTemp.body || "[]");

      const imageUrls = imageFilesData.map(
        (photoData) => `${S3_BUCKET_BASE_URL}/${photoData.object_key}`
      );

      allImageUrls = allImageUrls.concat(imageUrls);
    }

    //重複を排除して一括で Redux に更新
    const uniqueData = Array.from(new Set(allImageUrls));
    yield put(setAllImageDataByFileName(uniqueData));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.error(error);
    yield put(setPageTopLoader(false));
    yield put({ type: IMAGE.ERROR, payload: error.message });
  }
}
export default function* watchMapSettings() {
  yield takeEvery(IMAGE.GET_ALL_IMAGE_DATA_BY_FILENAME, handleAllImageDataByFileName);
}
